// Vanilla CSS for the title primitives (BaseTitle, SubTitle). Prefix: ttl-.
// Aggregated into libraryStyles.
export const titleStyles = `
  .ttl-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .ttl-title {
    font-size: var(--fs-2xl);
    font-weight: 500;
  }
  .ttl-count {
    padding: 0.5rem;
    font-size: var(--fs-base);
    color: var(--catchup-blue-600);
    border: 1px solid var(--catchup-blue-300);
    border-radius: var(--rad-catchup-3xlarge);
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    background-color: var(--catchup-blue-100);
  }
  .ttl-sub {
    font-size: var(--fs-xl);
    font-weight: 500;
    color: var(--catchup-darker-blue);
  }
`;
